import "twin.macro";
import { Link as HashLink } from "react-scroll";
import { Link } from "gatsby";
import React from "react";

const NavItems = ({ to, children, onClick, isHashLink, toHash, isLink }) => {
  return (
    <div>
      {isHashLink && !isLink ? (
        <HashLink
          activeClass="active"
          to={toHash}
          spy={true}
          smooth={true}
          duration={500}
          onClick={onClick}
          tw="md:inline-flex inline-block no-underline flex-wrap py-1.5 px-4 items-center text-black justify-center rounded-tr-3xl rounded-bl-3xl text-center cursor-pointer transition ease-out delay-150 duration-200"
        >
          {children}
        </HashLink>
      ) : (
        <Link
          to={to}
          onClick={onClick}
          tw="md:inline-flex inline-block no-underline flex-wrap py-1.5 px-4 items-center text-black justify-center rounded-tr-3xl rounded-bl-3xl text-center cursor-pointer transition ease-out delay-150 duration-200 "
        >
          {children}
        </Link>
      )}
    </div>
  );
};

export default NavItems;
